import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CoreTask } from './core-task';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';
import { HttpError } from '../errors';
import { Subject } from 'rxjs/Subject';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';

@Injectable()
export class CoreTaskService {
  private retrievalErrorBase = new Subject<boolean>();
  public retrievalError$ = this.retrievalErrorBase.asObservable();

  constructor(
    private http: HttpClient,
    private encryption: SemsoEncryptionModule
  ) { }

  public getCoreTasksByStudentAndCreboId(studentId: string, creboId: string): any {
    var id = this.encryption.decrypt(studentId);
    return this.http.get<CoreTask[]>(`/studenten/${id}/${creboId}`).pipe(catchError(error => {
      this.retrievalErrorBase.next(false);
      throw new HttpError(`Error retrieving the core tasks for student: ${id}`);
    }));
  }
}



// WEBPACK FOOTER //
// ./src/app/students/core-task.service.ts